import alertsService from '../services/alertsService.js';
import DAO from './DAO.js';

export default class AlertsDAO extends DAO {
  
  markAllReadByProjectId(projectId) {
    return alertsService.markAllReadByProjectId(projectId).then(alerts => {
      return alerts;
    });
  }

}



// WEBPACK FOOTER //
// ./src/dao/AlertsDAO.js